// src/pages/CollectionOrders/components/BatchStatusChange.tsx
import React, { useState } from 'react';
import SelectTwo from '../../../components/SelectTwo';
import useCollectionOrderService from '../../../app/services/hooks/useCollectionOrderService';
import { ServiceResponse } from '../../../app/services/shared/interfaces';
import { toast } from 'react-toastify';

interface BatchStatusOption {
  value: string;
  label: string;
}

interface Props {
  linkId: number;
  currentStatus?: string;
  currentStatusDisplay?: string;
  callbackSuccess?: () => void;
}

const BatchStatusChange: React.FC<Props> = ({
  linkId,
  currentStatus = 'ASSIGNED',
  callbackSuccess,
}) => {
  const { updateBatchStatus } = useCollectionOrderService();
  const [isChanging, setIsChanging] = useState(false);

  // Opciones de estado disponibles
  const statusOptions: BatchStatusOption[] = [
    { value: 'ASSIGNED', label: 'Asignado' },
    { value: 'COLLECTED', label: 'Acopiado' },
    { value: 'UNUSED', label: 'Sin utilizar' },
  ];

  const handleStatusChange = (option: { value: string; label: string } | null) => {
    if (!option || option.value === currentStatus) {
      return;
    }

    setIsChanging(true);
    updateBatchStatus(
      linkId,
      option.value,
      {
        onSuccess: (resp: ServiceResponse) => {
          toast.success(resp.message || 'Estado actualizado correctamente');
          if (callbackSuccess) {
            callbackSuccess();
          }
          setIsChanging(false);
        },
        onError: (resp: ServiceResponse) => {
          toast.error(resp.message || 'Error al actualizar el estado');
          setIsChanging(false);
        },
      }
    );
  };

  const currentOption = statusOptions.find((opt) => opt.value === currentStatus) || statusOptions[0];

  return (
    <div style={{ minWidth: '150px' }}>
      <SelectTwo
        name={`batch_status_${linkId}`}
        id={`batch_status_${linkId}`}
        inputValue={currentOption.value}
        options={statusOptions}
        onChange={handleStatusChange}
        placeholder="Seleccione estado"
        disabled={isChanging}
      />
    </div>
  );
};

export default BatchStatusChange;